export const tokenUrl = (typeof window === 'undefined') ? undefined : window._infl &&
  window._infl.hub && window._infl.hub.tokenUrl;
